import React, {Component} from "react"
import styled from "styled-components"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import browserImageSize from "browser-image-size"

import Loading from "@irati/ui/src/Loading"

import {H4} from "@irati/ui/src/Headings"
import getBase64 from "@irati/utils/images/getBase64"
import {uploadImage} from "@irati/images/services/image"
import ErrorText from "@irati/ui/src/ErrorText"
import add_a_file from "@irati/ui/images/add-a-file.png"

const StyledDropzone = styled(Dropzone)`
  width: 100%;
  border-width: 2px;
  border-color: #666;
  border-style: dashed;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 20px;
`

const Img = styled.img`
  margin: 30px;
`

const UnderlineStrong = styled.strong`
  text-decoration: underline;
`

const StyledDropzoneContents = styled.div`
  display: flex;
  align-content: flex-start;
  width: 100%;
`

const StyledH4 = styled(H4)`
  text-align: left;
  margin: 0;
`

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const ErrorTextWrapper = styled.div`
  white-space: nowrap;
`

class UploadImage extends Component {
  static propTypes = {
    dimensions: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    property: PropTypes.string.isRequired,
    maxSize: PropTypes.number
  }

  static defaultProps = {
    property: "cardImage",
    id: "uploadImage",
    dimensions: null,
    maxSize: 3
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleUpload = (file) => {
    const {property, onChange} = this.props
    return uploadImage(file).then((imgUrl) => {
      onChange(property, imgUrl)
    })
  }

  handleDrop = (acceptedFile, rejectedFile) => {
    const {dimensions, maxSize, formatMessage} = this.props
    if (rejectedFile.length > 0) {
      this.setState({
        uploadError: formatMessage({id: "admin.components.companyBenefits.uploadImage.uploadError"}, {maxSize})
      })
    } else {
      return getBase64(acceptedFile[0]).then((base64Image) => {
        const load = browserImageSize(base64Image).then((size) => {
          if (size.width < dimensions.width || size.height < dimensions.height) {
            throw new Error(formatMessage({id: "admin.components.companyBenefits.uploadImage.uploadFailed.error"}))
          } else {
            return this.handleUpload(base64Image)
          }
        })
        this.setState({load, uploadError: null})
      })
    }
  }

  render() {
    const {dimensions, maxSize} = this.props
    const {load, uploadError} = this.state
    let hint
    if (dimensions) {
      hint = <FormattedMessage
        id="admin.components.companyBenefits.uploadImage.hint"
        values={{width: dimensions.width, height: dimensions.height, maxSize}} />
    }

    const maxSizeInBytes = maxSize * 1024 * 1024

    return (
      <React.Fragment>
        <FlexWrapper>
          <div>
            <Loading load={load} />
            {uploadError && (
              <ErrorTextWrapper>
                <ErrorText>{uploadError}</ErrorText>
              </ErrorTextWrapper>)}
          </div>
        </FlexWrapper>
        <StyledDropzone
          name="benefit_card_img"
          accept="image/jpg,image/jpeg,image/png"
          onDrop={this.handleDrop}
          maxSize={maxSizeInBytes}>
          <StyledDropzoneContents>
            <Img src={add_a_file} height={80} alt="add_a_file" />
            <FlexWrapper>
              <StyledH4>
                <FormattedMessage
                  id="admin.components.companyBenefits.uploadImage.headerFour.dragAndDrop"
                  values={{browse: <UnderlineStrong>
                    <FormattedMessage id="admin.components.companyBenefits.uploadImage.browse.text" />
                  </UnderlineStrong>}} />
              </StyledH4>
              <p>{hint}</p>
            </FlexWrapper>
          </StyledDropzoneContents>
        </StyledDropzone>
      </React.Fragment>
    )
  }
}

export default injectIntl(UploadImage)
